<template>
    <v-dialog :value="value" max-width="520" :persistent="saving" content-class="pa-ui-overlay" @input="$emit('input', $event)">
        <v-card v-if="item" class="pa-card">
            <div class="pa-card__header">
                <div>
                    <h3 class="pa-section-title">Este documento não se aplica</h3>
                    <p class="pa-section-description">{{ item.document_type.name }} · {{ item.company_name }}</p>
                </div>
            </div>
            <div class="pa-card__body">
                <p class="rma-na__text">
                    Use quando a empresa não tem este documento no mês (por exemplo, não houve movimento na conta).
                    Explique o motivo: a Administração Judicial lê a justificativa e pode pedir o documento se for necessário.
                </p>
                <v-textarea v-model="text" label="Justificativa" outlined rows="3" auto-grow maxlength="2000" counter="2000"
                    :hint="tooShort ? 'Escreva pelo menos 5 caracteres.' : ''" persistent-hint :error-messages="error"
                    :disabled="saving" autofocus></v-textarea>
            </div>
            <div class="pa-card__footer">
                <v-btn outlined :disabled="saving" @click="$emit('input', false)">Cancelar</v-btn>
                <v-btn color="primary" depressed :loading="saving" :disabled="tooShort" @click="save">Confirmar</v-btn>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from "axios";
import { errorMessage } from "./rma.util";

// Marca o item como "nao se aplica" com justificativa obrigatoria. Emite `done`
// com a resposta da API ({ item, competence }).
export default {
    name: "RmaNotApplicableDialog",

    props: {
        value: { type: Boolean, default: false },
        item: { type: Object, default: null },
    },

    data: () => ({ text: "", error: null, saving: false }),

    computed: {
        tooShort() {
            return this.text.trim().length < 5;
        },
    },

    watch: {
        value(open) {
            if (!open) return;
            this.text = "";
            this.error = null;
        },
        text() {
            this.error = null;
        },
    },

    methods: {
        async save() {
            if (this.tooShort || !this.item) return;
            this.saving = true;
            this.error = null;
            try {
                const result = await axios.post(`/api/client/rma/items/${this.item.id}/not-applicable`, { justification: this.text.trim() });
                this.$emit("done", result.data.content);
                this.$emit("input", false);
                this.$dialog.notify.success("Documento marcado como \"não se aplica\".", { position: "top-right", timeout: 2500 });
            } catch (error) {
                this.error = errorMessage(error);
            } finally {
                this.saving = false;
            }
        },
    },
};
</script>

<style scoped>
.rma-na__text {
    font-size: 13.5px;
    color: #334155;
    line-height: 1.55;
    margin-bottom: 14px;
}
</style>
